import React, { useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { useSpring, animated as a } from 'react-spring'

import { useIsDesktop } from '../hooks'

import { Box } from 'system'
import { DocumentsNav } from './DocumentsNav'
import { HelpCard } from './HelpCard'
import { Button } from './Button'
import { ReactComponent as IconSignOutSVG } from '../assets/icon-signout.svg'

export const Menu = props => {
  const { openNav, closeNav, logoutUser } = useStoreActions(actions => ({
    openNav: actions.nav.openNav,
    closeNav: actions.nav.closeNav,
    logoutUser: actions.auth.logoutUser,
  }))
  const isNavOpen = useStoreState(state => state.nav.isNavOpen)
  const isDesktop = useIsDesktop()

  const animProps = useSpring({
    opacity: isNavOpen ? 1 : 0,
    transform: isNavOpen ? 'translate3d(0%, 0, 0)' : 'translate3d(-100%, 0, 0)',
  })

  useEffect(() => {
    isDesktop ? openNav() : closeNav()
  }, [openNav, closeNav, isDesktop])

  return (
    <Box
      as={a.div}
      style={isDesktop ? null : animProps}
      position={['absolute', 'static']}
      bg="white"
      top="56px"
      left={0}
      bottom={0}
      p={[3, 0]}
      zIndex={50}
      boxShadow={[
        '0 3px 6px hsla(0, 0%, 0%, .15), 0 2px 4px hsla(0, 0%, 0%, .12)',
        'none',
      ]}
      maxWidth={['18rem', 'none']}
      minHeight={['calc(100vh - 53px)', 'auto']}
      css={`
        transition: visibility 0.5s;
        visibility: ${isNavOpen ? 'visible' : 'hidden'};
      `}
      {...props}
    >
      <DocumentsNav />
      <Button
        iconSVG={IconSignOutSVG}
        colorScheme="white"
        display={['block', null, null, 'none']}
        mtScale="l"
        width={1}
        onClick={() => {
          closeNav()
          logoutUser()
        }}
      >
        Sign Out
      </Button>
      <HelpCard />
    </Box>
  )
}
